import { createBaseApiClient } from './baseApiClient';

function resolveUploadS3ApiBaseUrl(config) {
  return String(config?.uploadS3ApiBaseUrl || '').replace(/\/$/, '');
}

export function createUploadApiService(config) {
  const uploadS3ApiBaseUrl = resolveUploadS3ApiBaseUrl(config);
  const client = createBaseApiClient(config, uploadS3ApiBaseUrl);

  function resolveUploadPath({ isMediaUpload = true, isInternalZoneUpload = false, action }) {
    if (isInternalZoneUpload) {
      const internalZoneBasePath = isMediaUpload
        ? '/api/mfu/v1/internalzone/media'
        : '/api/mfu/v1/internalzone';

      switch (action) {
        case 'start':
          return `${internalZoneBasePath}/start-multipart-uploads`;
        case 'part-url':
          return `${internalZoneBasePath}/get-presigned-url`;
        case 'complete':
          return `${internalZoneBasePath}/multipart-uploads-complete`;
        case 'abort':
          return `${internalZoneBasePath}/abortupload`;
        default:
          throw new Error(`Unsupported upload action: ${action}`);
      }
    }

    if (action === 'start') {
      return isMediaUpload
        ? '/api/mfu/v1/media/start-multipart-uploads'
        : '/api/mfu/v1/start-multipart-uploads';
    }

    if (action === 'part-url') {
      return isMediaUpload
        ? '/api/mfu/v1/media/get-presigned-url'
        : '/api/mfu/v1/get-presigned-url';
    }

    if (action === 'complete') {
      return isMediaUpload
        ? '/api/mfu/v1/media/multipart-uploads-complete'
        : '/api/mfu/v1/multipart-uploads-complete';
    }

    if (action === 'abort') {
      return '/api/mfu/v1/abortupload';
    }

    throw new Error(`Unsupported upload action: ${action}`);
  }

  async function startMultipartUpload(payload, options = {}) {
    const path = resolveUploadPath({ ...options, action: 'start' });
    return client.post(path, payload);
  }

  async function getPresignedUrl({ key, uploadId, partNumber }, options = {}) {
    const pathPrefix = resolveUploadPath({ ...options, action: 'part-url' });
    const query = new URLSearchParams({
      key,
      uploadId,
      partNumber: String(partNumber)
    });

    return client.get(`${pathPrefix}?${query.toString()}`);
  }

  async function completeMultipartUpload(payload, options = {}) {
    const path = resolveUploadPath({ ...options, action: 'complete' });
    return client.post(path, payload);
  }

  async function abortMultipartUpload(payload, options = {}) {
    const path = resolveUploadPath({ ...options, action: 'abort' });
    return client.post(path, payload);
  }

  return {
    startMultipartUpload,
    getPresignedUrl,
    completeMultipartUpload,
    abortMultipartUpload,
    request: client.request,
    get: client.get,
    post: client.post,
    baseUrl: client.baseUrl,
    defaultHeaders: client.defaultHeaders
  };
}
